export const SEND_WORDS = 'SEND_WORDS';
export const GET_RECOMMENDATIONS = 'GET_RECOMMENDATIONS';
export const GET_DOMAIN_CHECKS = 'GET_DOMAIN_CHECKS';
export const GET_DOUBLEMEANING_CHECK = 'GET_DOUBLEMEANING_CHECKS';
